import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDomainsChooserComponent } from './user-domains-chooser.component';
import {DxSelectBoxModule, DxValidatorModule} from 'devextreme-angular';



@NgModule({
  declarations: [UserDomainsChooserComponent],
  imports: [
    CommonModule,
    DxSelectBoxModule,
  ],
  exports: [UserDomainsChooserComponent]
})
export class UserDomainsChooserModule { }
